import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import { sessionActions } from 'store';
import { trialStatusEnums, useModal } from 'utils';
import { CustomDelete, FullTable, NotError } from 'components';
import { DELETE_TRIAL_LOG_ACTION_TYPE, historyLogNotYet, rateHistoryBody, rateHistoryHead } from './constants';
import { authService } from '../../../../../store/clinical/session/session.service';

const ACTION_TYPE_SUCCESS = 'SAVE_SESSION_TARGET_OPTION_SUCCESS';

export const RateHistoryLog = ({ goal }) => {
    const sessionById = useSelector((state) => state.session.sessionById);
    const dispatch = useDispatch();
    const { open, close } = useModal();
    const [selectedRow, setSelectedRow] = useState(null);
    const [error, setError] = useState(null);
    const [load, setLoad] = useState(null);
    // Hide IN_PROGRESS trials — see trialHistoryLog for rationale.
    const completedTrials = (goal?.tSummary?.trials || []).filter(
        (t) => (t?.status || trialStatusEnums.COMPLETED) === trialStatusEnums.COMPLETED,
    );

    const handleChangeTime = (e) => {
        setSelectedRow((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        if (error) setError(null);
    };

    const actionForHistoryLog = (item, name) => {
        if (name === 'delete') {
            open(
                <CustomDelete
                    info="Delete this Log?"
                    text="Are you sure you want to delete this log?"
                    handleDel={() => dispatch(sessionActions.deleteTrialLog(sessionById?.id, goal?.tSummary?.id, item?.id))}
                    actionType={DELETE_TRIAL_LOG_ACTION_TYPE}
                />
            );
        }
        if (name === 'edit') {
            setSelectedRow(item);
        }
        if (name === 'remove') {
            setSelectedRow(null);
            setError(null);
        }
        if (name === 'save') {
            const startMoment = moment(selectedRow?.startTime);
            const endMoment = moment(selectedRow?.endTime);
            const hasStartTime = startMoment.isValid() && (startMoment.hour() !== 0 || startMoment.minute() !== 0);
            const hasEndTime = endMoment.isValid() && (endMoment.hour() !== 0 || endMoment.minute() !== 0);

            const missingStart = !hasStartTime;
            const missingEnd = !hasEndTime;
            const missingValue = selectedRow?.value === null || selectedRow?.value === undefined || selectedRow?.value === '';

            if (missingStart || missingEnd || missingValue) {
                setError(missingStart ? 'startTime' : missingEnd ? 'endTime' : 'value');
                return;
            }

            if (!endMoment.isAfter(startMoment)) {
                toast(<NotError type={'error'} errMessage={'End time cannot be before start time.'} />);
                setError('endBeforeStart');
                setLoad(false);
                return;
            }

            setLoad(true);
            const params = {
                goalId: goal?.tSummary?.goalId,
                targetId: goal?.tSummary?.targetId,
                sessionId: sessionById?.id,
                trialId: item?.id,
                label: selectedRow?.label,
                value: +selectedRow?.value,
                startTime: selectedRow?.startTime,
                endTime: selectedRow?.endTime,
            };
            authService
                .saveSessionTargetOptionService(params)
                .then((res) => {
                    dispatch({ type: ACTION_TYPE_SUCCESS, payload: res?.data });
                    setError(null);
                    setSelectedRow(null);
                    setLoad(false);
                    close();
                })
                .catch(() => {
                    setLoad(false);
                });
        }
    };

    return (
        <div style={{ width: 1200, maxWidth: '100%' }}>
            <div className="space-between">
                <p className="modal-header-title">History Log</p>
            </div>

            <div>
                <FullTable
                    head={rateHistoryHead(sessionById)}
                    body={rateHistoryBody(sessionById, selectedRow, handleChangeTime, error, load)}
                    list={completedTrials}
                    notYet={historyLogNotYet}
                    handleClickButton={actionForHistoryLog}
                    height={'auto'}
                    activeRowId={''}
                    margin={'16px 0 0 0'}
                />
            </div>
        </div>
    );
};
